import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function ValueSummary() {
  return <section className="w-full py-16 px-4 bg-brand-bg" data-id="element-155">
      <div className="max-w-3xl mx-auto bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_40px_rgba(212,168,67,0.15)]" data-id="element-156">
        <h3 className="text-2xl md:text-3xl text-center text-brand-gold font-bold mb-8" data-id="element-157">
          Esto es exactamente lo que recibes hoy:
        </h3>

        <div className="space-y-4" data-id="element-158">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/10 gap-2" data-id="element-159">
            <div className="flex items-center gap-3" data-id="element-160">
              <CheckIcon className="w-5 h-5 text-brand-green shrink-0" data-id="element-161" />
              <span className="text-brand-text font-medium" data-id="element-162">
                Método Sin-Tipster{' '}
                <span className="text-brand-muted font-normal" data-id="element-163">
                  (producto principal)
                </span>
              </span>
            </div>
            <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-164">
              <span className="text-brand-muted line-through" data-id="element-165">$318.00</span>
              <span className="text-brand-text font-medium min-w-[80px] text-right" data-id="element-166">
                $12.99
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/10 gap-2" data-id="element-167">
            <div className="flex items-center gap-3" data-id="element-168">
              <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-169" />
              <span className="text-brand-text font-medium" data-id="element-170">
                Bono #1: Manejo de Bank
              </span>
            </div>
            <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-171">
              <span className="text-brand-muted line-through" data-id="element-172">$197.00</span>
              <span className="text-brand-green font-bold min-w-[80px] text-right" data-id="element-173">
                GRATIS
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/20 gap-2" data-id="element-174">
            <div className="flex items-center gap-3" data-id="element-175">
              <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-176" />
              <span className="text-brand-text font-medium" data-id="element-177">
                Bono #2: Entiende Apuestas
              </span>
            </div>
            <div className="flex gap-8 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-178">
              <span className="text-brand-muted line-through" data-id="element-179">$97.00</span>
              <span className="text-brand-green font-bold min-w-[80px] text-right" data-id="element-180">
                GRATIS
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center py-4 pt-6 gap-2" data-id="element-181">
            <span className="text-xl text-brand-text font-bold" data-id="element-182">
              💰 VALOR EN BONOS
            </span>
            <div className="flex gap-8" data-id="element-183">
              <span className="text-xl text-brand-muted line-through" data-id="element-184">
                $294.00
              </span>
              <span className="min-w-[80px]" data-id="element-185"></span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}